import {h, Fragment} from "preact"
import { useSort } from "@nosto/preact"
import { useEffect, useState, useRef } from "preact/hooks";
import { sortOptions } from "../../config"
import Icon from "./Icon"
import Checkbox from "./Checkbox"

export default function SortDropdown({ openedFacetId, setOpenedFacetId, isInToolbar }) {
    const { activeSort, setSort } = useSort(sortOptions);
    const [ sortOpen, setSortOpen] = useState(false);
    const dropdownRef = useRef(null);
    
    const [optionName, setOptionName] = useState("");

    const handleSortChange = (event) => {
        // console.log(event.target)
        const inputField = event.target;
        const nextSibling = inputField.nextSibling;
        setSort(event.target.value);
        setOptionName(nextSibling.textContent);
        // toggleSort();
    };

    const toggleSort = () => {
        setSortOpen(prevSortOpen => !prevSortOpen);
    };

    // useEffect(()=>{
    //     if(toggledFacet === "ns-sort-tab"){
    //         if(!sortOpen){
    //             toggleSort();
    //         }
    //     } else {
    //         if(sortOpen){
    //             toggleSort();
    //         }
    //     }

    //     const inputFields = document.querySelectorAll(`input[name="ns-sort"]`);
    //     if(inputFields){
    //         const inputField = Array.from(inputFields).find(input => input.value === activeSort);
    //         if(inputField){
    //             const nextSibling = inputField.nextSibling;
    //             setOptionName(nextSibling.textContent);
    //         }
    //     }
    // }, [toggledFacet, setToggledFacet])

    // console.log(activeSort, "activeSort");
    // console.log(optionName, "optionName");
    // console.log(sortOpen, "sortOpen");

    useEffect(()=>{
        if(isInToolbar && sortOpen && openedFacetId !== "ns-sort-menu"){
            setSortOpen(false);
        }
        // const inputFields = document.querySelectorAll(`input[name="ns-sort"]`);
        // if(inputFields){
        //     const inputField = Array.from(inputFields).find(input => input.value === activeSort);
        //     if(inputField){
        //         const nextSibling = inputField.nextSibling;
        //         setOptionName(nextSibling.textContent);
        //     }
        // }
    }, [openedFacetId])

    function handleSortClick(){
        if(isInToolbar){
            toggleSort();
            setOpenedFacetId("ns-sort-menu");
        } else {
            toggleSort();
        }
    }

    // new logic for clicking outside of the facet 
    const toggleRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
          if (dropdownRef.current && !dropdownRef.current.contains(event.target) && toggleRef.current && !toggleRef.current.contains(event.target)) {
            if (sortOpen) {
                toggleSort();
              if (isInToolbar) {
                setOpenedFacetId(null);
              }
            }
          }
        };
    
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [sortOpen, setSortOpen, isInToolbar, setOpenedFacetId]);

    return (
        <div class="ns-dropdown-container accordian collection-filters__sort-by">
            <div class="justify-between">
                <button
                // button button--collapsible
                    className="ns-custom-sort-toggle-btn ns-font-bold ns-font-4"
                    type="button"
                    aria-haspopup="true"
                    aria-controls="ns-sort-dropdown"
                    aria-labelledby="sort-label"
                    aria-expanded={sortOpen}
                    tabIndex="0"
                    // onClick={()=>{
                    //     toggleSort();
                    //     setOpenedFacetId("ns-sort-menu");
                    // }}
                    onClick={()=> handleSortClick()}
                    ref={toggleRef}
                >
                    <img src="https://d21m4dsqdd3b9h.cloudfront.net/bigcommerce-f4083/onsiteContent/17458292354720.8538496855691255" alt="Sort Dropdown Icon" class="ns-sort-dropdown-icon" aria-hidden="false" />
                    <span
                        className="body-2 pr-[5px] pl-[16px] cursor-pointer lg:pl-[30px]"
                        id="sort-label"
                    >
                        Sort by
                    </span>
                    <span className="body-2--medium hidden lg:inline">
                        {sortOptions.find(option => option.id === activeSort)?.value?.name?.toLowerCase()}
                    </span>
                    <img src="https://d21m4dsqdd3b9h.cloudfront.net/bigcommerce-f4083/onsiteContent/17454922466190.8147754591327114" alt="Sort Dropdown Arrow" class="ns-sort-dropdown-arrow" aria-hidden="false" />
                </button>
            </div>
            
            <div
                // className="absolute bg-white m-w-full z-1"
                id="ns-sort-dropdown"
                aria-hidden={!sortOpen}
                ref={dropdownRef}
                tabIndex="0"
                class="content accordion__content"
                >
                    {/* bg-background-0 z-30 absolute mt-[20px] w-[200px] h-fit flex flex-col lg:w-[290px] lg:h-auto lg:pr-[0px] lg:right-0 lg:right-auto lg:mt-[2px] lg:top-[30px] lg:pt-[0px] */}
                <ul className="ns-sort-menu filter-group-display__list flex flex-col gap-y-15 ns-p-4">
                    {sortOptions.map((option) => {
                        // console.log(option.id)
                        return (
                        
                        <li 
                            key={option?.id}
                            // pb-[20px] pl-[20px] pr-[20px] lg:pb-[16px] lg:border-b-0
                            class="ns-sort-option filter-group-display__list-item"
                        >
                            <label
                                class="radio ns-checkbox"
                            >
                                <input
                                    className="sm"
                                    type="radio"
                                    name={`ns-sort-${isInToolbar ? 'toolbar' : ''}`}
                                    value={option?.id} 
                                    checked={(activeSort === option?.id)}
                                    onChange={(e) => {
                                        handleSortChange(e);
                                    }}
                                />
                                <span className="ns-checkmark" />
                                <span>
                                    {option.value.name}
                                </span>
                            </label>
                            {/* <Checkbox
                                value={option?.id}
                                selected={(activeSort === option?.id)}
                                onChange={e => {
                                    e.preventDefault();
                                    handleSortChange(e);
                                }}
                            /> */}
                        </li>
                    )})}
                </ul>
            </div>
        </div>
    )
}